import React from "react";
import { PortableText } from "@portabletext/react";
import autoImageBuilder from "helpers/imageBuilder";

// Define custom components for different block types and marks
const components = {
  types: {
    image: ({ value }) => (
      <img
        src={autoImageBuilder(value)}
        alt={value.alt || "Image"}
        className="rounded-md mb-4"
      />
    ),
  },
  block: {
    h1: ({ children }) => (
      <h1 className="text-xl sm:text-2xl md:text-4xl font-bold mb-2 sm:mb-4">
        {children}
      </h1>
    ),
    h2: ({ children }) => (
      <h2 className="text-lg sm:text-xl md:text-3xl font-bold mb-2 sm:mb-4">
        {children}
      </h2>
    ),
    h3: ({ children }) => (
      <h3 className="text-md sm:text-xl md:text-2xl font-bold mb-2 sm:mb-4">
        {children}
      </h3>
    ),
    h4: ({ children }) => (
      <h4 className="text-sm sm:text-md md:text-lg font-bold mb-2 sm:mb-4">
        {children}
      </h4>
    ),
    blockquote: ({ children }) => (
      <blockquote className="border-l-4 border-gray-500 pl-4 italic mb-2 sm:mb-4">
        {children}
      </blockquote>
    ),
    normal: ({ children }) => (
      <p className="text-[12px] sm:text-[14px] md:text-[16px] mb-2 sm:mb-4">
        {children}
      </p>
    ),
  },
  list: {
    bullet: ({ children }) => (
      <ul className="list-disc ml-2 sm:ml-4 md:ml-6 mb-2 sm:mb-4">
        {children}
      </ul>
    ),
  },
  marks: {
    strong: ({ children }) => <strong>{children}</strong>,
    em: ({ children }) => <em>{children}</em>,
    link: ({ children, value }) => (
      <a
        href={value.href}
        className="text-blue-500 hover:underline"
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
      </a>
    ),
  },
};

const RichText = ({ content }) => {
  return (
    <div className="prose prose-lg mb-6">
      <PortableText value={content} components={components} />
    </div>
  );
};

export default RichText;
